(function () {
    'use strict';

    angular.module("imApp").factory("fabricsGrpService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1241,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1242,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
